import { render, staticRenderFns } from "./RestaurantList.vue?vue&type=template&id=507cab1c&scoped=true&"
import script from "./RestaurantList.vue?vue&type=script&lang=js&"
export * from "./RestaurantList.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantList.vue?vue&type=style&index=0&id=507cab1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cab1c",
  null
  
)

export default component.exports